import Api from "./Api.ts";

export enum TripStatus {
    Processing = 'processing',
    NoDriversAvailable = 'no_drivers_available',
    Accepted = 'accepted',
    DriverCancelled = 'driver_cancelled',
    UserCancelled = 'user_cancelled',
    Verified='verified',
    Completed = 'completed',
    Aborted = 'aborted',
  }

export const getAllRides = async (page: number = 1, limit: number = 20, 
   status?: TripStatus, driverId?: number | null, userId?: number | null) => {
        let URL = `/ride/super_admin?page=${page}&limit=${limit}`;
        if(status) {
            URL += `&status=${status}`;
        }
        if(driverId) {
            URL += `&driverId=${driverId}`;
        }
        if(userId) {
            URL += `&userId=${userId}`;
        }
    const response = await Api.get(URL);
    return response.data;
  };


  export const getRideLogs = async (rideId: number) => {
    const URL = `/ride/${rideId}/logs`;
    const response = await Api.get(URL);
    return response.data;
  };

